module.exports = __webpack_public_path__ + "img/arh_8.92e3501e.jpg";